const claimBankDetailsQuestionCodes = {};

claimBankDetailsQuestionCodes.bankAccountType = 'bank-account-type';

claimBankDetailsQuestionCodes.accoutnHolderNameUk = 'account-holder-name-uk';

claimBankDetailsQuestionCodes.accoutnHolderNameInternational =
    'account-holder-name-inter';

claimBankDetailsQuestionCodes.accountNumber = 'account-number';

claimBankDetailsQuestionCodes.sortCode = 'sort-code';

claimBankDetailsQuestionCodes.iban = 'iban';

export default claimBankDetailsQuestionCodes;
